export default "__VITE_ASSET__DLEouLfL__"